import { Typography } from "@mui/material";
import React from "react";

export function NextButtonText({ currentPage }: { currentPage: string }) {
  const text =
    currentPage === "review"
      ? "View Results"
      : currentPage === "results"
      ? "Restart Survey"
      : "Next";

  return <Typography id="next-page-text">{text}</Typography>;
}
